export const RegexList = {
    number: /^[0-9\u0660-\u0669\u06F0-\u06F9]+$/,
    phoneNumber: /^(\\+98|0|\u0660|\u06F0)[\u0660-\u0669\u06F0-\u06F9\0-9]{10}$/,
    email: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/,
    aparat: "\\bhttps?:\\/\\/([a-z0-9-]+\\.)*aparat\\.com(\\/\\S*)?",
    url: "[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
}